import Action from '../base/action';

class MediaScreenPlay extends Action {
    mediaId;
    play;

    constructor(props) {
        super({...props, className: props.className || props.type + '_class'});
        this.mediaId = props.instanceId;
        this.play = props.play;
    }

    async execute({training}) {
        this.playMedia(this.play);
    }

    async stop() {
        this.playMedia(false, false);
    }

    playMedia(play, visible) {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);
        const mediaButton = MediaScreenPlay.getMediaPlayButton(media);
        if (isNullOrUndefined(media) || isNullOrUndefined(mediaButton)) {
            console.log("media doesn't exist for training");
            return;
        }

        if (play) {
            mediaButton.material.map = MediaScreenIcons.PAUSE;
            media.params.content.play();
        } else {
            mediaButton.material.map = MediaScreenIcons.PLAY;
            media.params.content.pause();
        }

        MediaScreenManager.createMedia(media, true);
        mediaButton.material.map.needsUpdate = true;
        if (visible !== undefined) MediaScreenManager.changeScreenVisibility(media.params.screenID, visible);
    }

    static getMediaPlayButton(media) {
        if (isNullOrUndefined(media)) {
            return undefined;
        }

        for (let index in media.children) {
            const mediaChild = media.children[index];
            if (mediaChild.actionType === ScreenButtonType.PAUSE) {
                return mediaChild;
            }
        }
        return undefined;
    }
}

export default MediaScreenPlay;
